var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { action, makeAutoObservable, observable } from "mobx";
import { getDocumentById } from "../api/documentDetails";
import { getAONStaffAccounts } from "../api/marketData/AonStaff";
import { getClientDropdownData } from "../api/marketData/AllStaffCrud";
import { getOktaUserEmail } from "../api/auth/okta";
import { isCarrierMatrixClient } from "../constants/carrierMatrixClients";
import { EAssociateType } from "../constants/Constants";
var ClientPageStore = /** @class */ (function () {
    function ClientPageStore() {
        var _this = this;
        Object.defineProperty(this, "apiLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "activeClientIds", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "selectedAonStaffAccount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "isUserHaveFullAccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "selectedClientDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(this, "showClientFeatures", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "selectedClientGuuid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "isCarrierMatrixClientSelected", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "handlePdfDownload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (docId) { return __awaiter(_this, void 0, void 0, function () {
                var docRespones, base64string, binaryString, len, bytes, i, blob, url, link, rawName, isPdf, fileName;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getDocumentById({ docId: docId })];
                        case 1:
                            docRespones = _a.sent();
                            base64string = docRespones.data.content;
                            binaryString = window.atob(base64string);
                            len = binaryString.length;
                            bytes = new Uint8Array(len);
                            for (i = 0; i < len; i++) {
                                bytes[i] = binaryString.charCodeAt(i);
                            }
                            blob = new Blob([bytes], { type: 'application/octet-stream' });
                            url = window.URL.createObjectURL(blob);
                            link = document.createElement('a');
                            link.href = url;
                            rawName = (docRespones.data.name || '').trim();
                            isPdf = !docRespones.data.mimeType || /pdf/i.test(docRespones.data.mimeType);
                            fileName = isPdf
                                ? "".concat(rawName.replace(/\.pdf$/i, '') || 'document', ".pdf")
                                : (/^\.[^.]+$/.test(rawName) ? "document".concat(rawName) : rawName || 'document');
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            return [2 /*return*/];
                    }
                });
            }); }
        });
        // Shared client-selection logic used by both the client search dropdown and the
        // Carrier Matrix nav-bar quick links. Carrier Matrix clients bypass the "Unauthorized
        // Aon Staff" gate - every colleague gets at least Read-Only access to them - but Client
        // Staff/AON Staff subtabs still get hidden for them via isCarrierMatrixClientSelected.
        // A colleague with an explicit Full Access record on one of these clients is treated the
        // same as Full Access on any other client - subtabs stay visible, nothing is hidden.
        Object.defineProperty(this, "selectClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (clientGuid, details, fallbackLabel) { return __awaiter(_this, void 0, Promise, function () {
                var isCarrierMatrix, aonStaffResponse, aonStaffAccounts, userEmail, userAccount, resolvedDetails, dropdown, match, hasFullAccess;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.setShowClientFeature(false);
                            this.setIsUserHaveFullAccess(false);
                            this.setIsCarrierMatrixClientSelected(false);
                            isCarrierMatrix = isCarrierMatrixClient(clientGuid);
                            return [4 /*yield*/, getAONStaffAccounts({ ClientGuid: clientGuid, Page: 1, PageSize: 1000 })];
                        case 1:
                            aonStaffResponse = _b.sent();
                            aonStaffAccounts = aonStaffResponse.data.value;
                            userEmail = getOktaUserEmail();
                            userAccount = aonStaffAccounts.find(function (item) { return item.colleagueEmail === userEmail; });
                            if (!userAccount && !isCarrierMatrix) {
                                this.setSelectedClientGuuid("");
                                this.storeSelectedClientDetails(null);
                                return [2 /*return*/, { success: false, message: "".concat((_a = details === null || details === void 0 ? void 0 : details.label) !== null && _a !== void 0 ? _a : fallbackLabel, ": Unauthorized Aon Staff") }];
                            }
                            resolvedDetails = details;
                            if (!(!resolvedDetails && fallbackLabel)) return [3 /*break*/, 3];
                            return [4 /*yield*/, getClientDropdownData({ QuickSearch: fallbackLabel })];
                        case 2:
                            dropdown = _b.sent();
                            match = dropdown.data.value.find(function (item) { return item.clientGuid.toLowerCase() === clientGuid.toLowerCase(); });
                            resolvedDetails = match ? __assign(__assign({}, match), { label: "".concat(match.name, " (").concat(match.code, ")") }) : { name: fallbackLabel, code: "", clientGuid: clientGuid, label: fallbackLabel };
                            _b.label = 3;
                        case 3:
                            hasFullAccess = (userAccount === null || userAccount === void 0 ? void 0 : userAccount.associateType) === EAssociateType.FULL_ACCESS;
                            this.setIsUserHaveFullAccess(hasFullAccess);
                            this.setIsCarrierMatrixClientSelected(isCarrierMatrix && !hasFullAccess);
                            this.setShowClientFeature(true);
                            this.setSelectedClientGuuid(clientGuid);
                            this.storeSelectedClientDetails(resolvedDetails);
                            return [2 /*return*/, { success: true }];
                    }
                });
            }); }
        });
        makeAutoObservable(this, {
            apiLoading: observable,
            setApiLoading: action,
            activeClientIds: observable,
            storeActiveClientsId: action,
            selectedAonStaffAccount: observable,
            setSelectedAonStaffAccount: action,
            isUserHaveFullAccess: observable,
            setIsUserHaveFullAccess: action,
            selectedClientDetails: observable,
            storeSelectedClientDetails: action,
            showClientFeatures: observable,
            setShowClientFeature: action,
            selectedClientGuuid: observable,
            setSelectedClientGuuid: action,
            isCarrierMatrixClientSelected: observable,
            setIsCarrierMatrixClientSelected: action,
        });
    }
    Object.defineProperty(ClientPageStore.prototype, "setSelectedAonStaffAccount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.selectedAonStaffAccount = value;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "setApiLoading", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.apiLoading = value;
        }
    });
    ;
    Object.defineProperty(ClientPageStore.prototype, "storeActiveClientsId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (ids) {
            this.activeClientIds = ids;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "setIsUserHaveFullAccess", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.isUserHaveFullAccess = value;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "setShowClientFeature", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.showClientFeatures = value;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "storeSelectedClientDetails", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.selectedClientDetails = value;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "setSelectedClientGuuid", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.selectedClientGuuid = value;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "setIsCarrierMatrixClientSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.isCarrierMatrixClientSelected = value;
        }
    });
    Object.defineProperty(ClientPageStore.prototype, "resetStore", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.storeActiveClientsId([]);
            this.setIsUserHaveFullAccess(false);
            this.storeSelectedClientDetails(undefined);
            this.setSelectedAonStaffAccount(null);
            this.setApiLoading(false);
            this.setSelectedClientGuuid("");
            this.setShowClientFeature(false);
            this.setIsCarrierMatrixClientSelected(false);
        }
    });
    return ClientPageStore;
}());
;
export default ClientPageStore;
